import { Component, Input } from '@angular/core';
import * as moment from 'moment';
import { MsgConfig } from 'src/app/app.messages';

@Component({
  selector: 'app-pickup-tooltip',
  templateUrl: './pickup-tooltip.component.html',
  styleUrl: './pickup-tooltip.component.scss',
  standalone: false
})
export class PickupTooltipComponent {
  @Input() pickupData: any[] = [];
  @Input() placement: string;
  @Input() forHistIcon: boolean = false;
  @Input() frmCommonData: boolean = false;
  constructor() {}
  ngOnInit() {
  }

  getFormattedPickupDate(pickupHist: any) {
    return this.frmCommonData ? pickupHist?.pickupDate : (pickupHist?.ExpDtTm ? moment.utc(pickupHist?.ExpDtTm).local().format(MsgConfig.DATE_TIME_FORMAT_UPPERCASE): '--')
  }
  getPickupQuantity(pickupHist: any) {
    return this.frmCommonData ? pickupHist?.quantity : (pickupHist?.IOUQty ? pickupHist?.IOUQty : pickupHist?.Qty);
  }
}
